import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { FolderLinkModel } from '../../../shared/folder-link.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../../shared/utils.service';
import { ApiRequestService } from '../../../shared/api-request.service';
import { UserPublicProfileComponent } from '../../../shared/user-public-profile/user-public-profile.component';
import { RBACService } from '../../../shared/rbac.service';

@Component({
  selector: 'app-account-docs-links-view',
  templateUrl: './account-docs-links-view.component.html',
  styleUrls: ['./account-docs-links-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccountDocsLinksViewComponent implements OnInit {
  folder_link: FolderLinkModel = new FolderLinkModel();
  folderContext: string = 'account';

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private utils: UtilsService,
    private api: ApiRequestService,
    private rbac: RBACService,
    private dialogRef: MatDialogRef<AccountDocsLinksViewComponent>
  ) {}

  // Expose RBACService to template
  protected readonly RBACService = RBACService;

  ngOnInit() {
    // get the folder context from parent
    this.folderContext = this.dialogData.folderContext || 'account';

    // Check permissions - close dialog if unauthorized
    const viewPermissions = this.getViewPermissionsForContext(
      this.folderContext
    );
    if (!this.rbac.userCanAccess(viewPermissions, true)) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view document links.'
      );
      this.dialogRef.close();
      return;
    }

    const folder_link_id = this.dialogData.folder_link_id;
    const folder_id = this.dialogData.folder_id;
    if (folder_link_id && folder_id) {
      this.getLink(folder_id, folder_link_id);
    }
  }

  private getLink(folder_id: number, folder_link_id: number) {
    this.api
      .makeRequest('get', `v2/folders/${folder_id}/links/${folder_link_id}`)
      .then((response) => {
        this.folder_link = response;
      })
      .catch((errorResponse) => {
        this.utils.handleAPIErrors(errorResponse);
      });
  }

  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }

  /**
   * Get view permissions for the given context.
   */
  private getViewPermissionsForContext(context: string): string[] {
    switch (context) {
      case 'account':
        return [
          RBACService.getPermission(
            RBACService.RBAC_F.F_ACCOUNT_COMPANY_DOCUMENTS,
            RBACService.RBAC_A.A_VIEW
          )
        ];
      case 'template':
        return [
          RBACService.getPermission(
            RBACService.RBAC_F.F_TEMPLATES_DOCUMENTS,
            RBACService.RBAC_A.A_VIEW
          )
        ];
      case 'site':
        return [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_VIEW
          ),
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES_DOCUMENTS,
            RBACService.RBAC_A.A_VIEW
          )
        ];
      case 'employee':
        return [
          RBACService.getPermission(
            RBACService.RBAC_F.F_EMPLOYEES,
            RBACService.RBAC_A.A_VIEW
          ),
          RBACService.getPermission(
            RBACService.RBAC_F.F_EMPLOYEES_TRAINING_COMPETENCIES,
            RBACService.RBAC_A.A_VIEW
          )
        ];
      default:
        return [];
    }
  }
}
